import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import ListSalesOrders from "app/pages/ConfirmSalesOrder/ListSalesOrder";

const routesName = "/dashboards/salesOrder";
const modules = "salesOrder";

export const salesOrderRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
        module: modules,
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={ListSalesOrders} />,
      },
      {
        path: `${routesName}/add`,
        // element: <Page component={AdminCustomers} />,
      },
      {
        path: `${routesName}/edit`,
        // element: <Page component={EditCloudstratClient} />,
      },
    ],
  },
];
